import { Link, useOutletContext } from 'react-router-dom';
import { BookOpen, Images, Leaf, PawPrint } from 'lucide-react';
import { PetHero } from '../../../components/portal/PetHero.jsx';

/**
 * The portal home: the selected pet as the emotional hero, plus soft shortcuts
 * into the diary, gallery and wellness path.
 */
export function PetHome() {
  const { selectedPet, pets } = useOutletContext();

  if (!selectedPet) {
    return (
      <div className="rounded-portal bg-portal-card p-10 text-center shadow-portal">
        <PawPrint className="mx-auto h-9 w-9 text-portal-ink-faint" strokeWidth={1.5} />
        <p className="mt-3 text-portal-ink-muted">
          Il tuo spazio è pronto. Appena registreremo il tuo animale, lo troverai qui.
        </p>
      </div>
    );
  }

  const shortcuts = [
    { to: '/account/diario', Icon: BookOpen, title: 'Diario', hint: 'La sua storia nel tempo' },
    { to: '/account/galleria', Icon: Images, title: 'Galleria', hint: 'Tutti i ricordi' },
    { to: '/account/benessere', Icon: Leaf, title: 'Benessere', hint: 'Consigli su misura' }
  ];

  return (
    <div className="space-y-8 pt-4">
      <PetHero pet={selectedPet} />

      <div className="grid gap-3 sm:grid-cols-3">
        {shortcuts.map((s) => (
          <Link
            key={s.to}
            to={s.to}
            className="flex items-center gap-3 rounded-portal bg-portal-card p-4 shadow-portal transition hover:-translate-y-0.5"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-portal-accent-soft text-portal-accent">
              <s.Icon className="h-5 w-5" strokeWidth={1.75} />
            </span>
            <span>
              <span className="block font-medium text-portal-ink">{s.title}</span>
              <span className="block text-sm text-portal-ink-muted">{s.hint}</span>
            </span>
          </Link>
        ))}
      </div>

      {pets.length > 1 && (
        <p className="text-center text-sm text-portal-ink-muted">
          Hai {pets.length} animali. Cambia animale dalla barra in alto.
        </p>
      )}
    </div>
  );
}
